// extracted by mini-css-extract-plugin
export default {"form":"CategoryForm_form__E9Rzr"};